/* istanbul ignore file */
import { createSelector } from 'reselect'

export const tokenSelector = (state) => state.token

export const tokenDataSelector = createSelector(
    tokenSelector,
    (token) => {
        if (!token.data) {
            return null
        }
        return token.data.keycloak
            ? `${token.data.keycloak.token_type} ${token.data.keycloak.access_token}`
            : token.data.idAnonymous
    }
)

export const publicTokenDataSelector = createSelector(
    tokenSelector,
    (token) => (!token.data) ? null : token.data.idAnonymous
)

export const oAuthTokenDataSelector = createSelector(
    tokenSelector,
    (token) => (!token.data || !token.data.keycloak)
        ? null
        : `${token.data.keycloak.token_type} ${token.data.keycloak.access_token}`
)
